import { Dialog } from "primereact/dialog";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { JVDate } from "../../shared/JVDate";
import { useEffect, useRef, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { InputTextarea } from "primereact/inputtextarea";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { InvoiceTracking } from "./Table";
import { getDates } from "../../shared/GetInvDates";
import { PaymentTerm } from "../../models/ConsultantMast";
import { Billing_Cycle, Payment_Term } from "../../models/FDropdown";
import { BillingCycle } from "../showPurchaseOrder/GeneratePO";
import { ILogin } from "../../models/Login";

interface IProps {
    open: boolean,
    singleData: IInvoiceTracking,
    toast?: any,
    hideDialog: () => void,
    action: boolean,
    loadTableData: () => void,
    loadTableDataCount: () => void,
    po: IPurchaseOrder,
    recent: InvoiceTracking,
};

export interface IInvoiceTracking {
    invoice_ID?: number | null,
    invoiceNO?: string | null,
    pO_ID?: number | null,
    consultant_ID?: number | null,
    fromDate?: Date | null,
    toDate?: Date | null,
    invoiceHours?: number | null,
    invoiceRate?: number | null,
    invoiceAmount?: number | null,
    invoiceDate?: Date | null,
    dueDate?: Date | null,
    preparedBy?: number | null,
    verfiedBy?: number | null,
    verifyComment?: string | null,
    invoiceStatus?: string | null,
    paymentStatus?: string | null,
    invoice_Cycle?: BillingCycle | null,
    payment_Term?: PaymentTerm | null,
    invoicePath?: string | null,
    createdOn?: Date | null,
    createdBy?: number | null,
    updatedOn?: Date | null,
    updatedBy?: number | null,
    verify?: boolean | null,
    balance_Rate?: number | null,
    is_Verfied?: boolean | null,
    is_Verified?: boolean | null,
    sRate?: number | null,
    mRate?: number | null,
    receivedAmount?: number | null,
    is_Credit_Note?: boolean | null,
    credit_Note_Comment?: string | null,
};

const schema = yup.object({
    invoiceNO: yup.string().required("Invoice NO is Required").nullable(),
    pO_ID: yup.number().required("PO ID is Required"),
    consultant_ID: yup.number().required("Consultant ID is Required"),
    fromDate: yup.date().required("From Date is Required").nullable(),
    toDate: yup.date().required("To Date is Required").nullable(),
    invoiceHours: yup.number().required("Invoice Hours is Required").max(270).typeError("Invoice Hours is Required"),
    invoiceRate: yup.number().required("PO ID is Required"),
    invoiceAmount: yup.number().nullable(),
    invoiceDate: yup.date().required("Invoice Date is Required").nullable(),
    dueDate: yup.date().required("Due Date is Required").nullable(),
    // preparedBy: yup.number().nullable(),
    // verfiedBy: yup.number().nullable(),
    // verifyComment: yup.string().nullable(),
    // paymentStatus: yup.string().required("Payment Status is Required"),
    invoice_Cycle: yup.string().required("Invoice Cycle is Required").nullable(),
    payment_Term: yup.string().required("Payment Term is Required").nullable(),
    invoiceStatus: yup.string().required("Invoice Status is Required").typeError("Invoice Status is Required").nullable(),
    // invoicePath: yup.string().nullable(),
    // createdOn: yup.date().nullable(),
    // createdBy: yup.number().nullable(),
    // updatedOn: yup.date().nullable(),
    // updatedBy: yup.number().nullable(),
    verify: yup.boolean().nullable(),
    // balance_Rate: yup.number().nullable().when("paymentStatus", {
    //     is: "Balance",
    //     then: yup.number().required("Balance Rate is required when Payment Status is 'Balance'"),
    // }),

});

export const GenerateInvoices = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [uploadedInvoice, setUploadedInvoice] = useState(false);
    const [reason, setReason] = useState("");
    const [isCredit, setIsCredit] = useState(false);
    const [credit_Note_Comment, setCredit_Note_Comment] = useState("");
    const [verify, setVerify] = useState(false);
    const [invoiceFile, setInvoiceFile] = useState<File | null | any>(null);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [submittedData, setSubmittedData] = useState<IInvoiceTracking | null>(null);
    const [confirmMessage, setConfirmMessage] = useState<string>("");
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IInvoiceTracking>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const ref = useRef<any>();

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const header = () => {
        return <p>Generate Invoices</p>;
    };
    const onHide = () => {
        props.hideDialog();
        setUploadedInvoice(false);
        setReason("");
        setVerify(false);
        setIsCredit(false);
    };

    const validateBillingCycle = (
        cycle?: BillingCycle | null,
        fromDate?: Date | null,
        toDate?: Date | null
    ): string | null => {

        if (!cycle || !fromDate || !toDate) return null;
        const from = new Date(fromDate);
        const to = new Date(toDate);

        if (to < from) return "To Date cannot be before From Date";
        const diffDays = Math.floor(
            (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24)
        );

        switch (cycle) {

            case BillingCycle.Monthly:
                const lastDay = new Date(from.getFullYear(), from.getMonth() + 1, 0);
                if (!(from.getDate() === 1 && to.getDate() === lastDay.getDate())) {
                    return "Monthly billing must be from 1st to last day of month.";
                }
                break;

            case BillingCycle.Weekly:
                if (diffDays !== 6) {
                    return "Weekly billing must have 7 days range.";
                }
                break;

            case BillingCycle.BiWeekly:
                if (diffDays !== 13) {
                    return "Bi-Weekly billing must have 14 days range.";
                }
                break;

            case BillingCycle.FourWeekly:
                if (diffDays !== 27) {
                    return "4-Weekly billing must have 28 days range.";
                }
                break;

            case BillingCycle.SemiMonthly:
                const lastDate = new Date(from.getFullYear(), from.getMonth() + 1, 0).getDate();
                if (!(
                    (from.getDate() === 1 && to.getDate() === 15) ||
                    (from.getDate() === 16 && to.getDate() === lastDate)
                )) {
                    return "Semi-Monthly must be 1–15 or 16–end of month.";
                }
                break;
        }
        return null;
    };

    const onSubmit = async (data: IInvoiceTracking) => {
        if (!(_roles.includes(1) || _roles.includes(26)) && props?.singleData?.paymentStatus !== undefined && props?.singleData?.paymentStatus !== null && (props?.singleData?.paymentStatus?.trim() === 'Paid' || props?.singleData?.paymentStatus?.trim() === 'Over Payment')) {
            props.toast.current.show({ severity: 'error', detail: "Paid Payment Status can not be updated", life: 3000 });
        } else if (data.invoiceStatus === null || data.invoiceStatus === "-- SELECT --") {
            props.toast.current.show({ severity: 'error', content: "Please Select Invoice Status." });
        } else if (props?.singleData?.invoice_ID != 0 && props?.singleData?.invoice_ID != null && data.invoiceHours == null) {
            props.toast.current.show({ severity: 'error', content: "Please Enter Invoice Hours." });
        }
        else {
            // if (props.recent === null) 
            {
                const message = validateBillingCycle(data.invoice_Cycle, data.fromDate, data.toDate);
                if (message && !confirmVisible) {
                    setConfirmMessage(
                        message + " Are you sure you want to proceed?"
                    );
                    setSubmittedData(data);
                    setConfirmVisible(true);
                    return;
                }
            }

            data.is_Verified = data.verify || props?.singleData?.is_Verfied;
            delete data.verify;
            delete data.verfiedBy;
            data.sRate = props.po.sRate;
            data.mRate = props.po.mRate;

            if (data.is_Credit_Note === true && credit_Note_Comment.trim() === "") {
                props.toast.current.show({ severity: 'error', content: "Please Give Some Comment For Credit Note." });
            }
            // else if (uploadedInvoice === false || (props?.singleData?.invoice_ID && (props?.singleData.invoicePath === null || (props?.singleData?.invoicePath || '')?.trim() === ''))) {
            //     props.toast.current.show({ severity: 'error', content: "Please Upload Invoice First." });
            // } 
            else {
                delete data.invoiceRate;
                setLoading(true);
                const method = (props?.singleData?.invoice_ID != 0 && props?.singleData?.invoice_ID != null) ? "PUT" : "POST";
                // const method = "POST";
                const message = (props.singleData?.invoice_ID != 0 && props.singleData?.invoice_ID != null) ? "Updated Successfully" : "Added Successfully";
                // const message = "Added Successfully";
                if (!(props.singleData?.invoice_ID != 0 && props.singleData?.invoice_ID != null)) {
                    delete data.invoice_ID;
                };

                if (props.action === true) {
                    data.verifyComment = reason;
                };

                if (data.is_Credit_Note === true) {
                    data.credit_Note_Comment = credit_Note_Comment.trim();
                }

                const formData = new FormData();
                formData.append('file', invoiceFile);
                formData.append('newInvoice', JSON.stringify(data));
                const params = {
                    method: method,
                    headers: {
                        'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                    },
                    body: formData
                };
                const response = await fetch(`${baseUrl}InvoiceTracking/${props?.singleData?.invoice_ID ? 'updateInvoice' : 'addInvoice'}` + (verify === true ? "?verify=1" : "?verify=0"), params);

                //const response = await Fetch("InvoiceTracking", method, data, verify === true ? "verify=1" : "verify=0", props.toast);
                if (response.ok) {
                    props.loadTableData();
                    props.loadTableDataCount();
                    props.hideDialog();
                    props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                    reset({});
                } else {
                    const message = await response.text();
                    props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
                }
                setLoading(false);
                setConfirmVisible(false);
            }
        }
    }
    const invoiceUpload = (event: FileUploadHandlerParam) => {
        if (event.files[0]) {
            if (event.files[0].size > 1024 * 1024 * 5) {
                props.toast.current.show({ severity: 'error', content: "File should be less than 5 MB." });
                event.options.clear();
            } else {
                setInvoiceFile(event.files[0]);
                setUploadedInvoice(prev => prev = true);
                props.toast.current.show({ severity: 'success', content: "File Selected" });
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A File." });
            event.options.clear();
        }
    };
    // const uploadeInvoice = async (invoice: File) => {
    //     let formData = new FormData();
    //     formData.append("invoice", invoice);

    //     const params = {
    //         method: "POST",
    //         headers: {
    //             'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
    //         },
    //         body: formData
    //     };
    //     setLoading(true);
    //     const response = await fetch(`${baseUrl}InvoiceTracking/invoice`, params);
    //     if (response) {
    //         props.toast.current.show({ severity: 'success', content: "Invoice Uploaded Successfully." });
    //         setLoading(false);
    //         setUploadedInvoice(true);
    //     } else setLoading(false);
    // }

    const Invoice_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Not Required", value: "Not Required" },
        { name: "Generated", value: "Generated" },
        { name: "Sent to Client", value: "Sent to Client" },
        { name: "Yet to Generated", value: "Yet to Generated" },
    ];
    const Payment_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Pending", value: "Pending" },
        { name: "Paid", value: "Paid" },
        { name: "Balance", value: "Balance" },
        { name: "Over Payment", value: "Over Payment" },
    ];

    const selectedPaymentStatus = watch("paymentStatus");

    const getTimesheetHours = async (fromDate: Date, toDate: Date) => {

        const response = await Fetch("Timesheet/getTimesheetHours", "POST", {
            PO_ID: props.po.pO_ID,
            FromDate: fromDate,
            ToDate: toDate
        }, null, props.toast);

        if (response) {
            const data: any = await response.json();

            setValue('invoiceHours', data.hours);
        }
    }
    // const downLoadInvoice = async () => {
    //     const params = {
    //         method: "GET",
    //         headers: {
    //             'Content-Type': 'application/pdf',
    //             'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
    //         }
    //     };
    //     try {
    //         const response = await fetch(`${baseUrl}${"InvoiceTracking/download"}?path=${props.singleData?.invoicePath}`, params);
    //         if (response.status === 200) {
    //             const blob = await response.blob();
    //             const href = window.URL.createObjectURL(blob);
    //             const a = document.createElement("a");
    //             a.download = `${props.singleData?.invoiceNO}.pdf`;
    //             a.href = href;
    //             a.click();
    //             a.href = '';
    //         } else if (response.status === 400) {
    //             const message = await response.text();
    //             props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
    //         }
    //     } catch {
    //         props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
    //     }
    // }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "fromDate") {
                if (value.fromDate != null) {
                    getTimesheetHours(value.fromDate, control._formValues.toDate);
                }
            }
            if (name === "toDate") {
                if (value.toDate != null) {
                    getTimesheetHours(control._formValues.fromDate, value.toDate);
                }
            }
            if (name === "invoiceHours") {
                if (value.invoiceHours != 0 && value.invoiceHours != null) {
                    control._formValues.invoiceAmount = control._formValues.invoiceRate * value.invoiceHours;
                    setValue('invoiceAmount', control._formValues.invoiceRate * value.invoiceHours);
                } else if (value.invoiceHours == 0 || value.invoiceHours == null) {
                    control._formValues.invoiceAmount = control._formValues.invoiceRate * 0;
                    setValue('invoiceAmount', control._formValues.invoiceRate * 0);
                }
            }
            if (name === "verify") {
                if (value.verify != null && value.verify === true) {
                    setVerify(prev => prev = true);
                } else setVerify(prev => prev = false);
            }
            if (name === "invoiceAmount") {
                if (value.invoiceHours != 0 && value.invoiceHours != null && value.invoiceAmount != 0 && value.invoiceAmount != null) {
                    control._formValues.balance_Rate = value.invoiceAmount - control._formValues.invoiceRate * value.invoiceHours;
                    setValue('balance_Rate', control._formValues.invoiceRate * value.invoiceHours - control._formValues.invoiceAmount);
                }
            }
            if (name === "invoiceDate") {
                if (value.invoiceDate != null) {
                    if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Thirty) {
                        // props.singleData.dueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date(new Date()).getDate() + 30));
                        setValue('dueDate', new Date(new Date(value.invoiceDate).setDate(new Date(value.invoiceDate).getDate() + 29)));
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Forty_Five) {
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 45));
                        setValue('dueDate', new Date(new Date(value.invoiceDate).setDate(new Date(value.invoiceDate).getDate() + 44)));
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Pay_On_Pay) {
                        //props.singleData.dueDate = new Date(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth(), lastDayOfMonth.getDay() + 45);
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Fifteen) {
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 15));
                        setValue('dueDate', new Date(new Date(value.invoiceDate).setDate(new Date(value.invoiceDate).getDate() + 14)));
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Sixty) {
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 60));
                        setValue('dueDate', new Date(new Date(value.invoiceDate).setDate(new Date(value.invoiceDate).getDate() + 59)));
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Seven) {
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 7));
                        setValue('dueDate', new Date(new Date(value.invoiceDate).setDate(new Date(value.invoiceDate).getDate() + 6)));
                    };
                }
            }
            if (name === "is_Credit_Note") {
                if (value.is_Credit_Note === true) {
                    setIsCredit(prev => prev = true);
                } else {
                    setIsCredit(prev => prev = false);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        if (props.open === true) {
            // if (props.po && props.recent.pO_ID && props.po.prime_Vendor_Billing_Cycle === "Monthly") {
            //     if (props.recent.toDate === null) {
            //         var month = new Date(props?.po?.project_Start_Date || "");
            //         var lastDayOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);
            //         props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
            //         props.singleData.toDate = new Date(lastDayOfMonth.toString());
            //         var lastDayOfMonthNextMonth = new Date(month.getFullYear(), month.getMonth() + 2, 0);
            //         //props.singleData.dueDate = new Date(lastDayOfMonthNextMonth.toString());

            //         props.singleData.invoiceDate = new Date();

            //     } else if (props.recent.toDate !== null) {
            //         // console.log(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? new Date(props.recent.toDate || "").getFullYear() + 1 : new Date(props.recent.toDate || "").getFullYear(), new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? 1 : 1));
            //         let getFromDateFullyear = new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? new Date(props.recent.toDate || "").getFullYear() + 1 : new Date(props.recent.toDate || "").getFullYear();
            //         let getFromDateMonth = new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? 0 : new Date(props.recent.toDate || "").getMonth() + 1;

            //         // props.singleData.fromDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getMonth() + 1));
            //         props.singleData.fromDate = new Date(getFromDateFullyear, getFromDateMonth, 1);

            //         var lastDayOfMonth = new Date(props.singleData.fromDate.getFullYear(), props.singleData.fromDate.getMonth() + 1, 0);
            //         props.singleData.toDate = new Date(lastDayOfMonth.toString());
            //         var lastDayOfMonthNextMonth = new Date(props.singleData.toDate.getFullYear(), props.singleData.toDate.getMonth() + 2, 0);

            //         props.singleData.invoiceDate = new Date();
            //     }

            //     if (props.po.prime_Vendor_Payment_Term === "Net 30") {
            //         // props.singleData.dueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date(new Date()).getDate() + 30));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
            //         props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 45));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
            //         //props.singleData.dueDate = new Date(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth(), lastDayOfMonth.getDay() + 45);
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
            //         props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 15));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
            //         props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 60));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
            //         props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 7));
            //     };
            // }
            // if (props.po && props.recent.pO_ID && props.po.prime_Vendor_Billing_Cycle === "Weekly") {
            //     if (props.recent.toDate === null) {
            //         props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
            //         const currentDate = new Date(props?.po?.project_Start_Date || "");
            //         let numberOfDaysToAdd = (7 - Number(new Date(props?.po?.project_Start_Date || "")?.getDay())) - 2;
            //         const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
            //         props.singleData.toDate = toDate;
            //         props.singleData.invoiceDate = new Date();
            //         //const dueDate = new Date((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).setDate((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).getDate() + 7));

            //         //props.singleData.dueDate = dueDate;
            //     } else if (props.recent.toDate !== null) {
            //         // console.log(props.recent.toDate);
            //         const fromDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 3));
            //         props.singleData.fromDate = fromDate;
            //         // console.log(props.singleData.fromDate);
            //         const toDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 7));
            //         props.singleData.toDate = toDate;
            //         //const dueDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 14));
            //         //props.singleData.dueDate = dueDate;
            //         props.singleData.invoiceDate = new Date();
            //     }

            //     if (props.po.prime_Vendor_Payment_Term === "Net 30") {
            //         props.singleData.dueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 45))
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
            //         //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 15))
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 60))
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 7))
            //     };
            // }
            // if (props.po && props.recent.pO_ID && props.po.prime_Vendor_Billing_Cycle === "Semi-Monthly") {
            //     if (props.recent.toDate === null) {

            //         props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
            //         const currentDate = new Date(props?.po?.project_Start_Date || "");
            //         let numberOfDaysToAdd = (7 - Number(new Date(props?.po?.project_Start_Date || "")?.getDay())) - 2;
            //         const toDate = new Date(currentDate.setDate(currentDate.getDate() + (numberOfDaysToAdd + 7)));

            //         let toDateYear = props.singleData.fromDate.getFullYear();
            //         let toDateMonth = props.singleData.fromDate.getMonth();
            //         let toDateDay = props.singleData.fromDate.getDate() < 16 ? 15 : new Date(props.singleData.fromDate.getFullYear(), props.singleData.fromDate.getMonth() + 1, 0).getDate();

            //         props.singleData.toDate = new Date(toDateYear, toDateMonth, toDateDay);
            //         props.singleData.invoiceDate = new Date();
            //         //const dueDate = new Date((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).setDate((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).getDate() + 21));
            //         //props.singleData.dueDate = dueDate;

            //     } else if (props.recent.toDate !== null) {
            //         // console.log(new Date(new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? new Date(props.recent.toDate || "").getFullYear() + 1 : new Date(props.recent.toDate || "").getFullYear(), new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? 1 : new Date(props.recent.toDate || "").getMonth(), 1));
            //         let toDateYear = new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? new Date(props.recent.toDate || "").getFullYear() + 1 : new Date(props.recent.toDate || "").getFullYear();
            //         let toDateMonth = new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? 0 : new Date(props.recent.toDate || "").getMonth() + 1;
            //         let toDateDay = new Date(props.recent.toDate || "").getDate() > 15 ? 1 : 16;

            //         // const fromDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 3));
            //         const fromDate = new Date(toDateYear, toDateMonth, toDateDay);

            //         props.singleData.fromDate = fromDate;
            //         const toDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() < 16 ? 15 : new Date(fromDate.getFullYear(), fromDate.getMonth(), 0).getDate());
            //         //new Date(fromDate.getFullYear(), fromDate.getMonth(), 0).getDate()
            //         props.singleData.toDate = toDate;
            //         //const dueDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 35));
            //         //props.singleData.dueDate = dueDate;
            //         props.singleData.invoiceDate = new Date();
            //     }
            //     if (props.po.prime_Vendor_Payment_Term === "Net 30") {
            //         props.singleData.dueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 45));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
            //         //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 15));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 60));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 7));
            //     };
            // }
            // if (props.po && props.recent.pO_ID && props.po.prime_Vendor_Billing_Cycle === "Bi-Weekly") {
            //     if (props.recent.toDate === null) {

            //         props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
            //         const currentDate = new Date(props?.po?.project_Start_Date || "");
            //         let numberOfDaysToAdd = (7 - Number(new Date(props?.po?.project_Start_Date || "")?.getDay())) - 2;
            //         const toDate = new Date(currentDate.setDate(currentDate.getDate() + (numberOfDaysToAdd + 7)));

            //         props.singleData.toDate = toDate;
            //         props.singleData.invoiceDate = new Date();
            //         //const dueDate = new Date((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).setDate((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).getDate() + 21));
            //         //props.singleData.dueDate = dueDate;

            //     } else if (props.recent.toDate !== null) {
            //         const fromDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 1));

            //         props.singleData.fromDate = fromDate;
            //         const currentDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 1));
            //         const toDate = new Date(currentDate.setDate(currentDate.getDate() + (14)));
            //         props.singleData.toDate = toDate;
            //         props.singleData.invoiceDate = new Date();
            //     }
            //     if (props.po.prime_Vendor_Payment_Term === "Net 30") {
            //         props.singleData.dueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 45));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
            //         //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 15));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 60));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 7));
            //     };
            // }
            // if (props.po && props.recent.pO_ID && props.po.prime_Vendor_Billing_Cycle === "4-Weekly") {
            //     if (props.recent.toDate === null) {

            //         props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
            //         const currentDate = new Date(props?.po?.project_Start_Date || "");
            //         let numberOfDaysToAdd = (7 - Number(new Date(props?.po?.project_Start_Date || "")?.getDay())) - 2;
            //         const toDate = new Date(currentDate.setDate(currentDate.getDate() + (numberOfDaysToAdd + 21)));

            //         props.singleData.toDate = toDate;
            //         props.singleData.invoiceDate = new Date();

            //     } else if (props.recent.toDate !== null) {
            //         const fromDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 1));

            //         props.singleData.fromDate = fromDate;
            //         const currentDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 1));
            //         const toDate = new Date(currentDate.setDate(currentDate.getDate() + (28)));
            //         props.singleData.toDate = toDate;
            //         props.singleData.invoiceDate = new Date();
            //     }
            //     if (props.po.prime_Vendor_Payment_Term === "Net 30") {
            //         props.singleData.dueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 45));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
            //         //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 15));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 60));
            //     }
            //     else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
            //         props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 7));
            //     };
            // }
            // if (new Date(props.singleData.toDate || "") > new Date(props.po.project_End_Date || "") && props.recent.pO_ID) {
            //     props.singleData.toDate = new Date(props.po.project_End_Date || "");
            //     props.singleData.invoiceDate = new Date(props.po.project_End_Date || "");
            //     props.singleData.dueDate = null;
            // }

            if (props.singleData.verify === true) {
                setVerify(prev => prev = true);
            };

            if (props.singleData.invoice_ID !== null && props.singleData.invoice_ID !== undefined && props.singleData.invoice_ID !== 0) {
                if (!props.singleData.dueDate || props.singleData.dueDate === null || props.singleData.dueDate === undefined) {
                    props.singleData.invoiceDate = new Date();
                    if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Thirty) {
                        props.singleData.dueDate = new Date(new Date().setDate(new Date(new Date()).getDate() + 30));
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Forty_Five) {
                        props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 45));
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Pay_On_Pay) {
                        //respDueDate = new Date(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth(), lastDayOfMonth.getDay() + 45);
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Fifteen) {
                        props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 15));
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Sixty) {
                        props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 60));
                    }
                    else if (props.po.prime_Vendor_Payment_Term === PaymentTerm.Net_Seven) {
                        props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 7));
                    };
                }
                reset({ ...props.singleData, verify: props.singleData.verify });
            } else {
                const values = getDates({ pO_ID: props?.recent?.pO_ID || null, toDate: props?.recent?.toDate ? new Date(props?.recent?.toDate || "") : null }, { Billing_Cycle: props?.po?.prime_Vendor_Billing_Cycle || null, Payment_Term: props.po.prime_Vendor_Payment_Term || null, project_Start_Date: new Date(props.po.project_Start_Date || ""), project_End_Date: new Date(props.po.project_End_Date || ""), timesheet_Week_Start_Day: (props.po.timesheet_Week_Start_Day ?? 0) });
                props.singleData.fromDate = values.FromDate;
                props.singleData.toDate = values.ToDate;
                props.singleData.dueDate = values.DueDate;
                props.singleData.invoiceDate = values.InvoiceDate;

                reset({ ...props.singleData, verify: props.singleData.verify });
                getTimesheetHours(values.FromDate, values.ToDate);
            };
            /*
            invoiceNO
            pO_ID
            consultant_ID
            fromDate
            toDate
            invoiceHours
            invoiceRate
            invoiceAmount
            invoiceDate
            dueDate
            invoice_Cycle
            payment_Term
            invoiceStatus
            verify 
            */


            if (props.singleData?.invoicePath != null && props.singleData?.invoicePath.trim() != "") {
                setUploadedInvoice(true);
            }
            if (props.singleData?.is_Verfied === false) {
                setVerify(true);
                setReason(props.singleData?.verifyComment || "");
            }
        }
    }, [props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header={header} className="p-fluid" onHide={onHide} draggable={false}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVInput column={6} label="Invoice#" control={control} name="invoiceNO" error={errors.invoiceNO?.message} disabled={props.action} />
                    <JVDate column={6} label="From Date" control={control} name="fromDate" error={errors.fromDate?.message} disabled={props.action} />
                    <JVDate column={6} label="To Date" control={control} name="toDate" error={errors.toDate?.message} disabled={props.action} />
                    <JVInput column={6} label="Hour" control={control} name="invoiceHours" error={errors.invoiceHours?.message} disabled={props.action} />
                    <JVInput column={6} label="S.Rate" control={control} name="invoiceRate" disabled />
                    <JVInput column={6} label="Amount" control={control} name="invoiceAmount" disabled error={errors.invoiceAmount?.message} />
                    <JVDate column={6} label="Inv Date" control={control} name="invoiceDate" error={errors.invoiceDate?.message} disabled={props.action} />
                    <JVDate column={6} label="Due Date" control={control} name="dueDate" error={errors.dueDate?.message} disabled={props.action} />
                    {/* <JVDropdown required column={6} label="Billing Cycle" control={control} name="prime_Vendor_Billing_Cycle" options={Billing_Cycle} optionLabel="name" optionValue="id" placeholder="Select Invoice Cycle" /> */}
                    <JVDropdown column={6} label="Billing Cycle" disabled control={control} name="invoice_Cycle" options={Billing_Cycle} optionLabel="name" optionValue="id" placeholder="Select Billing Cycle" error={errors.invoice_Cycle?.message} />
                    {/* <JVDropdown required column={6} label="Payment Term" control={control} name="prime_Vendor_Payment_Term" options={Payment_Term} optionLabel="name" optionValue="name" placeholder="Select Invoice Cycle" /> */}
                    <JVDropdown column={6} label="Payment Term" disabled control={control} name="payment_Term" options={Payment_Term} optionLabel="name" optionValue="id" placeholder="Select Payment Term" error={errors.payment_Term?.message} />
                    <JVDropdown column={6} label="Invoice Status" control={control} name="invoiceStatus" options={Invoice_Status} optionLabel="name" optionValue="name" placeholder="Select Invoice Status" error={errors.invoiceStatus?.message} disabled={props.action} />
                    {/* <JVDropdown column={6} label="Payement Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" error={errors.paymentStatus?.message} disabled={props.action} /> */}
                    {/* {selectedPaymentStatus === "Balance" && <JVInput required column={6} label="Balance Amount" control={control} name="balance_Rate" error={errors.balance_Rate?.message} />} */}
                    {/* <JVInput required column={6} label="Balance Rate" control={control} name="balance_Rate" error={errors.balance_Rate?.message} /> */}
                    {props.singleData?.invoice_ID && <div className="field col-12 md:col-2 pt-5">
                        <JVCheckbox label="Verify" control={control} name="verify" />
                    </div>}
                    <div className="field col-12 md:col-2">
                        <span className="">Invoice <span style={{ color: 'red' }}>*</span></span>
                        <FileUpload className="mt-2" chooseLabel="Choose Invoice" mode="basic" name="invoice" accept=".pdf" customUpload auto uploadHandler={invoiceUpload} />
                    </div>
                    {/* {props.action === true && <div className="field col-12 md:col-2">
                        <span className="">Invoice</span>
                        <Button className="mt-2" label="Invoice" icon="pi pi-download" onClick={downLoadInvoice} type="button" />
                    </div>} */}
                    {(props?.singleData?.paymentStatus === "Pending" || props?.singleData?.paymentStatus === "Balance") && <div className="field col-12 md:col-2 pt-5">
                        <JVCheckbox label="Is Credit Note" control={control} name="is_Credit_Note" />
                    </div>}
                    {isCredit && <div style={{ width: "100%", paddingLeft: "13px", marginRight: "13px" }}>
                        <label htmlFor="reason">Credit Note Reason<span style={{ color: 'red' }}>*</span> </label>
                        <InputTextarea name="credit_Note_Comment" placeholder="Write Credit Note reason" value={credit_Note_Comment} onChange={(e) => setCredit_Note_Comment(e.target.value)} rows={5} cols={30} maxLength={300} autoResize />
                    </div>}

                    {verify && props.singleData?.invoice_ID && <div style={{ width: "100%", paddingLeft: "13px", marginRight: "13px" }}>
                        <label htmlFor="reason"> Reason<span style={{ color: 'red' }}>*</span> </label>
                        <InputTextarea name="reason" placeholder="write the reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={5} cols={30} maxLength={300} autoResize />
                    </div>}
                    <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                        <Button className="field col-12 md:col-6  h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => reset(props.singleData)} type="button"></Button>
                    </div>
                    {/* {props.action === true && <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                        <Button className="field col-12 md:col-6 h-2rem" label="VERIFY" type="submit" loading={loading} onClick={() => {
                        }}></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={() => {
                            reset({});
                            props.hideDialog();
                            setReason("");
                        }}></Button>
                    </div>} */}
                </form>
            </Dialog>
            <Dialog visible={confirmVisible} header="Confirmation" onHide={() => setConfirmVisible(false)} className="confirm-dialog">
                <p className="confirm-message">{confirmMessage}</p>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
                    <Button label="Yes" onClick={() => { if (submittedData) { onSubmit(submittedData); } }}></Button>
                    <Button label="No" className="p-button-outlined" onClick={() => { setConfirmVisible(false); setSubmittedData(null); }} />
                </div>
            </Dialog>
        </>
    );
}